import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
@Component({
    selector: "app-search-page",
    templateUrl: "./search-page.component.html",
    styleUrls: ["./search-page.component.scss"],
    standalone: false
})
export class SearchPageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
